@if (props.options && props.options | formlySelectOptions : field | async; as opts) { @for (opt of opts; track opt) {
<input
  type="radio"
  [formControl]="formControl"
  [value]="opt.value"
  [id]="id + '_' + opt.value"
  class="form-check-input"
  [ngClass]="props.inputClass"
  [attr.data-testing-id]="'radio-' + opt.label"
/>
<label class="form-check-label pr-3" [attr.for]="id + '_' + opt.value">{{ opt.label }}</label>
} }
